import {
  $jingleCollectionsTableFilters,
  $jingleCollectionsTablePage,
  $jingleCollectionsTablePageSize,
  $jingleCollectionsTableSearch,
  $jingleCollectionsTableSort,
  type JingleCollectionsSortState,
} from '@/entities/jingle-collections'
import { type GetApiTracksQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { createStore, sample } from 'effector'
import { createGate } from 'effector-react'

// Gate
export const JinglesListPageJingleCollectionsGate = createGate()

// Last state

// Filters
export const $jinglesListPageLatestJingleCollectionsFilters =
  createStore<GetApiTracksQueryParams>({})
sample({
  source: $jingleCollectionsTableFilters,
  clock: JinglesListPageJingleCollectionsGate.close,
  target: $jinglesListPageLatestJingleCollectionsFilters,
})
// Sort
export const $jinglesListPageLatestJingleCollectionsSort =
  createStore<JingleCollectionsSortState>({
    field: null,
    order: null,
  })
sample({
  source: $jingleCollectionsTableSort,
  clock: JinglesListPageJingleCollectionsGate.close,
  target: $jinglesListPageLatestJingleCollectionsSort,
})
// Page
export const $jinglesListPageLatestJingleCollectionsPage =
  createStore<number>(DEFAULT_PAGE)
sample({
  source: $jingleCollectionsTablePage,
  clock: JinglesListPageJingleCollectionsGate.close,
  target: $jinglesListPageLatestJingleCollectionsPage,
})
// Page size
export const $jinglesListPageLatestJingleCollectionsPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
sample({
  clock: JinglesListPageJingleCollectionsGate.close,
  source: $jingleCollectionsTablePageSize,
  target: $jinglesListPageLatestJingleCollectionsPageSize,
})
// Search
export const $jinglesListPageLatestJingleCollectionsSearch =
  createStore<string>('')
sample({
  clock: JinglesListPageJingleCollectionsGate.close,
  source: $jingleCollectionsTableSearch,
  fn: (search) => search || '',
  target: $jinglesListPageLatestJingleCollectionsSearch,
})
